// extracted by mini-css-extract-plugin
export default {"item":"CommentItem_item__+vwzS"};